/**
 * APIで使う汎用エラー
 */
export class ApiError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = this.constructor.name;
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export function fatalError(message?: string): never {
  throw new ApiError(message ?? 'Fatal error.');
}
